import { format } from "date-fns";
import type { useSipStats } from "creso-core/hooks";
import { formatShort, titleCase } from "creso-core/utils";
import { StatTile } from "../../primitives";
import { StatsBar } from "./stats-bar";

export type SipStatsData = NonNullable<
  ReturnType<typeof useSipStats>["data"]
>;

export function SipStats({
  stats,
  className,
}: {
  stats?: SipStatsData;
  className?: string;
}) {
  if (!stats) return null;

  return (
    <StatsBar className={className}>
      <StatTile
        label="Monthly Installments"
        value={
          stats.total_active_sip_amount
            ? formatShort(stats.total_active_sip_amount)
            : "-"
        }
      />
      <StatTile label="Active SIPs" value={stats.active_sip_count} />
      <StatTile
        label="Total Invested"
        value={
          stats.total_invested_amount
            ? formatShort(stats.total_invested_amount)
            : "-"
        }
      />
      {stats.frequencies && (
        <StatTile
          label="Frequency"
          value={stats.frequencies.map((f) => titleCase(f)).join(", ")}
        />
      )}
      {stats.next_installment_date && (
        <StatTile
          label="Next Installment"
          value={format(stats.next_installment_date, "PP")}
        />
      )}
    </StatsBar>
  );
}
